{
    "dev": {
        "AssetMaintenancePostSubscriptionKey": "88677f28012e41c4af2a0968ce34ccb9",
        "AssetMaintenanceSubscriptionKey": "c77b5427c8d34bffabbf62082a66672c",
        "clientId": "27a29eb3-cb6d-49b6-9733-fee3067c161c",
        "tenantId": "37a72eb7-1faf-49d3-9ddc-6b923b751bc0",
        "AssetMaintenanceKey": "e7bfc5295d0745a49e865d214dc53732"
    },
    "prod": {
        "AssetMaintenancePostSubscriptionKey": "",
        "AssetMaintenanceSubscriptionKey": "",
        "clientId": "",
        "tenantId": "",
        "AssetMaintenanceKey": ""
    }
}